<template>
    <base-modal
        modal-id="promoModal"
        modal-dialog="centered,promo"
    >
        <template #title>
            <h5 class="modal-title glitch-text glitch-text--promo">Отправить купон на E-mail</h5>
        </template>
        <template>
            <promo-form />
        </template>
    </base-modal>
</template>

<script>
import BaseModal from './base-modal';
import PromoForm from '../promo-form';

export default {
    name: 'promo-modal',

    components: { BaseModal, PromoForm },

    data() {
        return {
            count: 1,
        };
    },
};
</script>
